import { api } from "../../helpers/api/handler"

export const passwordResetRequest = (email: string) =>
  api
    .post<{ detail: string }>(
      "/auth/password/reset/",
      JSON.stringify({ email })
    )
    .then(({ detail }) => detail)
